export default __webpack_public_path__ + "static/media/prob_solution.9452b784.png";